import { routes } from "common/routes/routes";
import { useMatch } from "react-router-dom";

export type JumpTo = "providers" | "appointmentTypes";

export const useJumpToPath = (jumpTo: JumpTo): string => {
  const JumpLink = {
    providers: {
      oldPath: "/booking/providers",
      newPath: "/settings/bhb/providers"
    },
    appointmentTypes: {
      oldPath: "/booking/appointment-types",
      newPath: "/settings/bhb/appointment-types"
    }
  };

  const isOldBookingPath = !!useMatch(
    `${routes.appointmentBooking.basePath.path}/*`
  );

  const { oldPath, newPath } = JumpLink[jumpTo];
  return isOldBookingPath ? oldPath : newPath;
};
